// extracted by mini-css-extract-plugin
export var breakpointLG = "1280px";
export var breakpointSM = "768px";
export var breakpoints = "'@theme/breakpoints.module.css'";
export var styles_component = "TwoColumnLayout-module--styles_component--86b2a";
export var styles_content = "TwoColumnLayout-module--styles_content--e20de";
export var styles_sidebar = "TwoColumnLayout-module--styles_sidebar--837f0";